/* Site-wide: hide the sticky header while scrolling down, bring it back as soon as the shopper scrolls up (like rhodeskin.com).
   Stays visible near the top of the page and whenever a menu, search or cart drawer is open (the page is scroll-locked then). */
(function(){
  var header = document.getElementById('shopify-section-header');
  if (!header) return;
  var root = document.documentElement;
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  var THRESHOLD = 6;
  function locked(){
    return getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(root).overflow === 'hidden';
  }
  function update(){
    ticking = false;
    var y = window.pageYOffset || 0;
    var h = header.offsetHeight || 80;
    if (y <= h || locked()) {
      root.classList.remove('nav-hidden');
    } else if (y > lastY + THRESHOLD) {
      root.classList.add('nav-hidden');
    } else if (y < lastY - THRESHOLD) {
      root.classList.remove('nav-hidden');
    }
    if (Math.abs(y - lastY) > THRESHOLD) lastY = y;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  /* Keyboard users tabbing into the header always see it */
  header.addEventListener('focusin', function(){ root.classList.remove('nav-hidden'); });
})();